import { useEffect, useRef } from 'react';
import useRefreshStore from '@store/useRefreshStore';

/**
 * Pull-to-Refresh 전용 훅. 초기 마운트에서는 실행되지 않고, refreshKey 변경 시에만 fetchFn을 실행하여 완료 후 네이티브에 알림
 * @param {Function} fetchFn - 데이터를 가져오는 함수 (Promise를 반환해야 refresh 완료 시점이 정확함)
 * @param {Array} deps - 추가 의존성 배열 (refreshKey는 자동 포함)
 */
const useRefreshCallback = (fetchFn, deps = []) => {
    const refreshKey = useRefreshStore((state) => state.refreshKey);
    const prevRefreshKey = useRef(refreshKey);
    const fetchFnRef = useRef(fetchFn);
    fetchFnRef.current = fetchFn;

    useEffect(() => {
        const isRefresh = prevRefreshKey.current !== refreshKey;
        prevRefreshKey.current = refreshKey;

        if (!isRefresh) return;

        useRefreshStore.getState().registerRefresh();

        const result = fetchFnRef.current();

        if (result && typeof result.finally === 'function') {
            result.finally(() => useRefreshStore.getState().completeRefresh());
        } else {
            useRefreshStore.getState().completeRefresh();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshKey, ...deps]);
};

export default useRefreshCallback;
